<ng-template #removeProfileModal let-modal>
  <div class="modal-container">
    <h1>Excluir perfil do jogo</h1>
    <br />
    <p>
      Tem certeza que deseja excluir todas as informações do jogo? Todas os dados, palpites, classificações serão
      perdidas
    </p>
    <div class="login-buttons button-container">
      @if (loading) {
        <div class="spinner-container">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      }
      <button mat-raised-button [disabled]="loading" color="warn" (click)="removeProfile()">Sair e Remover</button>
      &nbsp; &nbsp;
      <button mat-raised-button [disabled]="loading" (click)="dismissModal()">Cancelar</button>
    </div>
    <label class="error"></label>
  </div>
</ng-template>

<div class="folha-back">
  <div class="folha">
    <h1>Preferências</h1>
    <div class="pref-container">
      @if (image$ | async) {
        <div class="imagem-usuario">
          <img src="{{ image$ | async }}" alt="Imagem do usuário" (error)="handleMissingImage($event)" />
        </div>
      }
      <form class="border border-light" [formGroup]="prefFormGroup" (validSubmit)="submit()">
        <mat-form-field class="mat-input-wrapper" appearance="outline">
          <mat-label>Identificação</mat-label>
          <input matInput type="text" formControlName="userId" class="input-com-ajuda" /><mat-icon
            class="ajuda"
            matTooltip="Essa informação identifica cada usuário de forma única. Os palpites serão auditados utilizando este identificador"
            >info</mat-icon
          >
        </mat-form-field>
        <mat-form-field class="mat-input-wrapper">
          <mat-label>Nome</mat-label>
          <input
            matInput
            type="text"
            formControlName="name"
            placeholder="Nome"
            [errorStateMatcher]="matcher"
            required />
          @if (name?.invalid) {
            <mat-error>{{ getNameError() }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mat-input-wrapper" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="text" formControlName="email" />
        </mat-form-field>
        @if (pref?.providerGoogle || pref?.providerFacebook) {
          <div class="mat-input-wrapper">
            <mat-slide-toggle formControlName="showImage" color="primary"> Exibir imagem </mat-slide-toggle>
            <div class="ajuda-container">
              <mat-icon class="ajuda" matTooltip="A imagem pode ser exibida aos integrantes do grupo que faça parte"
                >info</mat-icon
              >
            </div>
          </div>
        }
        <h2>Notificações</h2>
        <div class="mat-input-wrapper">
          <mat-slide-toggle formControlName="auditoria" color="primary"> Auditoria </mat-slide-toggle>
          <div
            class="ajuda-container"
            matTooltip="Você receberá um e-mail no momento que o jogo iniciar com os palpites de todos os participantes do grupo">
            <mat-icon class="ajuda">info</mat-icon>
          </div>
        </div>
        <div class="mat-input-wrapper">
          <mat-slide-toggle formControlName="avisos" color="primary"> Avisos </mat-slide-toggle>
          <div
            class="ajuda-container"
            matTooltip="Receba avisos de jogos que estarão iniciando e não possuem palpites, resultados, etc.">
            <mat-icon class="ajuda">info</mat-icon>
          </div>
        </div>
        <h2>Autenticação</h2>
        @if (pref?.provider === 'password') {
          <div class="mat-input-wrapper">
            <mat-slide-toggle formControlName="providerPassword" color="primary"> E-mail </mat-slide-toggle>
          </div>
        }
        <div class="mat-input-wrapper">
          <mat-slide-toggle
            (change)="linkLogin($event, providerEnum.Google)"
            formControlName="providerGoogle"
            color="primary">
            Google
          </mat-slide-toggle>
        </div>
        <div class="mat-input-wrapper">
          <mat-slide-toggle
            (change)="linkLogin($event, providerEnum.Facebook)"
            formControlName="providerFacebook"
            color="primary">
            Facebook
          </mat-slide-toggle>
        </div>
      </form>
    </div>
    <div class="action-buttons">
      <button mat-raised-button (click)="reset()" [disabled]="loading">Cancelar</button>
      <button
        mat-raised-button
        (click)="submit()"
        color="primary"
        [disabled]="!prefFormGroup?.valid || prefFormGroup?.pristine || loading || !online">
        Gravar
      </button>
    </div>
    <div class="version-info">BolCó - {{ version }}</div>
    <div class="action-buttons">
      <button
        mat-raised-button
        (click)="openRemoveForm()"
        color="warn"
        [disabled]="!canRemoveProfile || loading || !online">
        Sair e Remover o Perfil
      </button>
      @if (!canRemoveProfile) {
        <div
          class="ajuda-container"
          matTooltip="Para excluir o perfil é necessário sair de todos os grupos ou excluí-los">
          <mat-icon class="ajuda">info</mat-icon>
        </div>
      }
    </div>
  </div>
</div>
